import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { optionOwnerHasTransportEnabled } from "../../models/common/consts";
import { useAppOptionValueEquals } from "../../hooks/framework/useAppOptionValue";
import { LoadingIndicator } from "../framework/loadingIndicator";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../framework/redux/hooks";
import { addErrorMsg } from "../../framework/redux/slices/appSlice";
import { useTranslation } from "react-i18next";

export const TransportBase = () => {
    const [transportEnabled, loading] = useAppOptionValueEquals(
        optionOwnerHasTransportEnabled,
        true
    );
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (!(loading || transportEnabled)) {
            dispatch(addErrorMsg({ message: t("common.permissionDenied") }));
            navigate("/", { replace: true });
        }
    }, [loading, transportEnabled]);

    if (loading) {
        return <LoadingIndicator />;
    }

    return <Outlet />;
};
